module.exports = __webpack_public_path__ + "static/media/LegoCaveSpiderQueenLabA0121b_design_clean_v002.7fefecab.png";